import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Detay sayfalarındaki "Geri" butonu için güvenli geri-dönüş.
 *
 * - Uygulama içinden gelindiyse `navigate(-1)` → önceki (filtreli) URL'e döner,
 *   liste sayfasının arama/filtre/scroll state'i korunur.
 * - Deep-link / sayfa yenileme ile açıldıysa (geçmiş yok) `fallbackPath`'e gider
 *   (navigate(-1) uygulamadan çıkarabilirdi).
 *
 * React Router v6: ilk/başlangıç location'ının `key`'i 'default'tur; gerçek bir
 * uygulama-içi navigasyondan sonra benzersiz bir key alır.
 *
 * @param {string} fallbackPath geçmiş yoksa gidilecek temiz yol (ör. '/recete/listesi')
 * @returns {() => void}
 */
export default function useGoBack(fallbackPath) {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(() => {
    if (location.key && location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(fallbackPath);
    }
  }, [navigate, location.key, fallbackPath]);
}
